module.exports = __webpack_public_path__ + "public/Icons/userProfile.svg?7556f0df";